import React, { useContext, useEffect, useState } from "react";
import { ContentZoneContext } from "cms/components/context/index";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isArrayEmpty, isArrayNotEmpty } from "utils/empty-exists";
import { HeroSlideshowSlide } from "cms/components/components/hero-slideshow/display/hero-slideshow-slide";
import { useImageLoader } from "cms/components/components/hero-slideshow/display/use-image-loader";
import { Logger } from "cms/utils/log/logger";

const HeroSlideshowComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { slides = [] } = component || {};
    const hasContent = isArrayNotEmpty(slides);
    const total = slides?.length ?? 0;
    
    const {
        fetchImageData,
        preloadImageArray
    } = useImageLoader();
    
    const [loading, setLoading] = useState(true);
    const [index, setIndex] = useState(0);
    const [images, setImages] = useState(null);
    
    const buildImageSlidesData = async (slides) => {
        const datas = [];
        if (isArrayEmpty(slides)) {
            return [];
        }
        try {
            for (const slide of slides) {
                const { image } = slide || {};
                const { image: image_guid } = image || {};
                if (image_guid) {
                    const data = await fetchImageData(image_guid);
                    datas.push(data);
                }
            }
            const images = await preloadImageArray(datas);
            setImages(images);
            setLoading(false);
            
        } catch (err) {
            Logger.error(err);
            setLoading(false);
        }
        return images;
    };
    
    useEffect(() => {
        buildImageSlidesData(slides);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slides]);
    
    function moveIndex (increment) {
        let idx = index + increment;
        if (idx > slides.length - 1) {
            idx = 0;
        }
        if (idx < 0) {
            idx = slides.length - 1;
        }
        setIndex(idx);
    }

    if (loading) {
        return <></>;
    } else if (isArrayEmpty(slides)) {
        return (
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
            />
        );
    } else {
        return (
            <div className="slideshow-container">
                <HeroSlideshowSlide
                    slides={slides}
                    images={images}
                    key={index}
                    index={index}
                    total={total}
                    moveIndex={moveIndex}
                />
            </div>
        );
    }
};

HeroSlideshowComponentDisplay.displayName = "HeroSlideshowComponentDisplay";
export { HeroSlideshowComponentDisplay };
